import React from 'react';
import { cn } from '../../lib/utils';

const LOGO_FULL = '/images/logo-full.png';

/**
 * Shared authentication / public account shell.
 * Preserves form logic in child pages — only visual structure.
 */
export default function AuthShell({
  children,
  title,
  description,
  footer,
  maxWidthClass = 'max-w-[420px]',
  className,
}) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4 py-12 sm:px-6">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-50 via-background to-background dark:from-brand-500/10"
      />
      <div className={cn('relative w-full', maxWidthClass, className)}>
        <div className="mb-10">
          <img src={LOGO_FULL} alt="OMNICHEK" className="h-9 object-contain" />
        </div>
        <div className="rounded-modal border border-border bg-card p-8 shadow-oc-md">
          {title ? (
            <h1 className="font-heading text-[1.75rem] font-semibold tracking-tight text-foreground">
              {title}
            </h1>
          ) : null}
          {description ? (
            <p className="mt-2 text-[0.9375rem] text-muted-foreground">{description}</p>
          ) : null}
          <div className={cn((title || description) && 'mt-8')}>{children}</div>
        </div>
        {footer ? <div className="mt-8">{footer}</div> : null}
      </div>
    </div>
  );
}
